/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const RequestQuoteFormScript = {
	/**
	 * @description Initialize
	 */
	init: function() {
		this.formScript();
	},

	formScript: function() {
		const formSelector = '.request-quote-form-block__form'; // Adjust if your Gravity Form wrapper differs
		const popupSelector = '.request-quote-form-block__popup';

		/**
		 * @description Validate email format
		 * @param {string} email - The email address to validate
		 * @returns {boolean} True if the email is valid, false otherwise
		 */
		const isValidEmail = (email) => {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailPattern.test(email);
		};

		// /**
		//  * @description Validate phone number format
		//  * @param {string} phone - The phone number to validate
		//  * @returns {boolean} True if the phone number is valid, false otherwise
		//  */
		// const isValidPhoneNumber = (phone) => {
		// 	const phonePattern = /^[0-9\-+()\s]{10,15}$/;
		// 	return phonePattern.test(phone);
		// };

		/**
		 * @description Check if Gravity Form fields are filled and valid
		 * @returns {boolean} True if all required fields are filled and valid, false otherwise
		 */
		const areAllFieldsFilled = () => {
			let allValid = true;

			$(`${formSelector} .gfield`).each(function() {
				const $input = $(this).find('input, select, textarea');
				const value = $input.val();

				// Skip validation for non-required fields
				if ($input.attr('aria-required') !== 'true') {
					console.log('Skipping validation for non-required field:', $input.attr('name'));
					return;
				}

				// Check if the field is empty
				if (!value) {
					console.log('Field is empty:', $input.attr('name'));
					allValid = false;
					return false; // Exit loop early if a field is empty
				}

				// Additional validation for email
				if ($input.attr('type') === 'email' && !isValidEmail(value)) {
					console.log('Email is invalid:', $input.attr('name'));
					allValid = false;
					return false;
				}
			});

			return allValid;
		};

		// Button click handler
		$('.request-quote-form-block__form-btn').on('click', function(event) {
			event.stopPropagation();
			$('.request-quote-form-block__form-btn').addClass('active');

			if (areAllFieldsFilled()) {
				// Open popup if all required fields are filled and valid
				$(popupSelector).addClass('show');
			} else {
				// Trigger Gravity Forms submit if any field is empty or invalid
				$(`${formSelector} .gform_footer .gform_button`).trigger('click');
			}
		});

		// Close popup when clicking outside content
		$(popupSelector).on('click', function(event) {
			if (!$(event.target).closest('.request-quote-form-block__popup-content').length) {
				event.stopPropagation();
				$('.js-checkbox-req-quote .ginput_container .gchoice .gfield-choice-input').prop('checked', false);
				$(popupSelector).removeClass('show');
				$('.request-quote-form-block__form-btn').removeClass('active');
			}
		});

		// Close popup when clicking close button
		$('.request-quote-form-block__popup-close').on('click', function(event) {
			event.stopPropagation();
			$('.js-checkbox-req-quote .ginput_container .gchoice .gfield-choice-input').prop('checked', false);
			$(popupSelector).removeClass('show');
			$('.request-quote-form-block__form-btn').removeClass('active');
		});

		// Submit button handlers
		$('.js-submit-form-no-contact').on('click', function(event) {
			event.stopPropagation();
			$('.js-checkbox-req-quote .ginput_container .gchoice .gfield-choice-input').prop('checked', false);
			const link = $(this).attr('href');
			window.open(link, '_blank');
			$(popupSelector).removeClass('show');
			$(`${formSelector} .gform_footer .gform_button`).trigger('click');
		});

		$('.js-submit-form-contact').on('click', function(event) {
			event.stopPropagation();
			$(popupSelector).removeClass('show');
			$('.js-checkbox-req-quote .ginput_container .gchoice .gfield-choice-input').prop('checked', true);
			$(`${formSelector} .gform_footer .gform_button`).trigger('click');
		});
	},
};

export default RequestQuoteFormScript;
